// menu.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GenericCollectionService } from './collection-service.service';

export interface Topic {
  id: string;
  name: string;
  icon: string;
}

@Injectable({ providedIn: 'root' })
export class MenuService {
  private isMenuOpenSubject = new BehaviorSubject<boolean>(false);
  isMenuOpen$ = this.isMenuOpenSubject.asObservable();

  constructor(private collectionService: GenericCollectionService<any>) {
  }

  topics: Topic[] = [
    { id: 'shabbat', name: 'שבת', icon: 'synagogue' }, // Represents the weekly event/observance, or wb_twilight / nightlight for candles
    { id: 'isurVeHeter', name: 'איסור והיתר', icon: 'restaurant' }, // Represents dietary laws/kashrut, or rule / fact_check for permitted/forbidden
    { id: 'niddah', name: 'נידה', icon: 'water_drop' }, // Represents purity/mikveh water
    { id: 'kidushin', name: 'חופה וקידושין', icon: 'wc' }, // Represents male/female union
    { id: 'israel_land_laws', name: 'מצוות התלויות בארץ', icon: 'forest' }, // Represents agriculture/land
    // Add more topics as needed
  ];
  get isMenuOpen(): boolean {
    return this.isMenuOpenSubject.getValue();
  }

  getTopics(): Topic[] {
    return this.topics;
  }

  toggleMenu(): void {
    this.isMenuOpenSubject.next(!this.isMenuOpenSubject.getValue());
  }

  openMenu(): void {
    this.isMenuOpenSubject.next(true);
  }

  closeMenu(): void {
    this.isMenuOpenSubject.next(false);
  }

  checkScreenSize(): void {
    const shouldBeOpen = window.innerWidth > 768;
    this.isMenuOpenSubject.next(shouldBeOpen);
  }

  getCurrentTopicName(): string {
    const topic = this.topics.find(t => t.id === this.collectionService.getCurrentTopic());
    return topic ? topic.name : 'הכנה לבחינות רבנות';
  }
}
